(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fieldory-announcement"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function tick() {
    var timers = document.querySelectorAll('[data-fy-countdown]');
    for (var i = 0; i < timers.length; i++) {
      var el = timers[i];
      var ends = parseInt(el.getAttribute('data-ends'), 10);
      var clock = el.querySelector('[data-fy-clock]');
      if (!ends || !clock) continue;

      var left = ends - Math.floor(Date.now() / 1000);
      if (left <= 0) {
        var bar = el.closest('.fy-announce');
        if (el.getAttribute('data-expire') === 'hide' && bar) {
          bar.hidden = true;
        } else {
          el.hidden = true;
        }
        continue;
      }

      var days = Math.floor(left / 86400);
      var hours = Math.floor((left % 86400) / 3600);
      var mins = Math.floor((left % 3600) / 60);
      var secs = left % 60;
      clock.textContent =
        (days > 0 ? days + 'd ' : '') + pad(hours) + ':' + pad(mins) + ':' + pad(secs);
    }
  }

  tick();
  setInterval(tick, 1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fieldory-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', function (event) {
  const select = event.target.closest('[data-fy-market-select]');
  if (!select) return;
  const wrap = select.closest('.fy-header__market');
  const picked = select.options[select.selectedIndex];
  if (wrap && picked) {
    const country = wrap.querySelector('[data-fy-market-country]');
    const currency = wrap.querySelector('[data-fy-market-currency]');
    if (country) country.textContent = picked.getAttribute('data-country') || '';
    if (currency) currency.textContent = picked.getAttribute('data-currency') || '';
    wrap.classList.add('is-busy');
  }
  if (select.form) select.form.submit();
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  const active = document.activeElement;
  if (active && active.closest && active.closest('.fy-nav__item--has-panel') && active.blur) active.blur();
});

document.addEventListener('click', function (event) {
  const toggle = event.target.closest('[data-fy-menu-toggle]');
  if (!toggle) return;
  const drawer = document.getElementById(toggle.getAttribute('aria-controls'));
  if (!drawer) return;
  const open = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!open));
  drawer.hidden = open;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fieldory-product-main"] && !Shopify.designMode) return;
  try {
    
/* Dispatch date. The server renders it, but a cached page would hand the
   customer yesterday's date, so recompute against the visitor's own clock. */
(function () {
  function shipLabel(cutoff, skipWeekends) {
    var d = new Date();
    if (d.getHours() >= cutoff) d.setDate(d.getDate() + 1);
    if (skipWeekends) {
      if (d.getDay() === 6) d.setDate(d.getDate() + 2);
      else if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    }
    var day = d.getDate();
    var m100 = day % 100;
    var m10 = day % 10;
    var ord = 'th';
    if (m100 < 11 || m100 > 13) {
      if (m10 === 1) ord = 'st';
      else if (m10 === 2) ord = 'nd';
      else if (m10 === 3) ord = 'rd';
    }
    var wd = d.toLocaleDateString('en-GB', { weekday: 'short' });
    var mon = d.toLocaleDateString('en-GB', { month: 'short' });
    return wd + ', ' + day + ord + ' ' + mon;
  }

  function paint() {
    document.querySelectorAll('[data-fy-ship]').forEach(function (el) {
      var slot = el.querySelector('[data-fy-ship-text]');
      var tpl = el.getAttribute('data-template');
      if (!slot || !tpl) return;
      var cutoff = parseInt(el.getAttribute('data-cutoff'), 10);
      if (isNaN(cutoff)) cutoff = 14;
      var skip = el.getAttribute('data-skip-weekends') === '1';
      var date = document.createElement('span');
      date.className = 'fy-ship__date';
      date.textContent = shipLabel(cutoff, skip);
      var parts = tpl.split('[date]');
      slot.textContent = '';
      slot.appendChild(document.createTextNode(parts[0] || ''));
      if (parts.length > 1) {
        slot.appendChild(date);
        slot.appendChild(document.createTextNode(parts.slice(1).join('[date]')));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paint);
  } else {
    paint();
  }
  document.addEventListener('shopify:section:load', paint);
})();

/* Fieldory product page behaviour.
   Custom elements are used so the theme editor re-upgrades them when a
   section or block is re-rendered. */

class FieldoryGallery extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-fy-track]');
    this.thumbs = Array.from(this.querySelectorAll('[data-fy-thumb]'));
    this.slides = Array.from(this.querySelectorAll('[data-fy-slide]'));
    this.dots = Array.from(this.querySelectorAll('.fy-gal__dot'));
    if (!this.track) return;

    this.thumbs.forEach((t) =>
      t.addEventListener('click', () => this.select(parseInt(t.dataset.index, 10)))
    );

    if ('IntersectionObserver' in window && this.slides.length) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) this.markActive(parseInt(e.target.dataset.index, 10));
          });
        },
        { root: this.track, threshold: 0.6 }
      );
      this.slides.forEach((s) => this.observer.observe(s));
    }

    if (this.dataset.zoom === 'true') this.bindZoom();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  select(index) {
    const slide = this.slides[index];
    if (!slide) return;
    this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
    this.markActive(index);
  }

  selectByMediaId(mediaId) {
    const i = this.slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
    if (i > -1) this.select(i);
  }

  markActive(index) {
    this.thumbs.forEach((t, i) => {
      const on = i === index;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', String(on));
    });
    this.dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
  }

  bindZoom() {
    const dialog = this.closest('.fy-pdp')?.querySelector('[data-fy-zoom]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const img = dialog.querySelector('[data-fy-zoom-img]');
    const close = dialog.querySelector('[data-fy-zoom-close]');

    this.querySelectorAll('[data-fy-zoomable]').forEach((el) => {
      el.addEventListener('click', () => {
        img.src = el.dataset.zoomSrc || el.currentSrc || el.src;
        img.alt = el.alt || '';
        dialog.showModal();
      });
    });
    close?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
  }
}
if (!customElements.get('fieldory-gallery')) customElements.define('fieldory-gallery', FieldoryGallery);

class FieldoryProduct extends HTMLElement {
  connectedCallback() {
    const data = this.querySelector('[data-fy-variants]');
    try { this.variants = JSON.parse(data.textContent); } catch (e) { this.variants = []; }

    this.gallery = this.querySelector('fieldory-gallery');
    this.idInput = this.querySelector('[data-fy-variant-id]');
    this.optionGroups = Array.from(this.querySelectorAll('[data-fy-option]'));

    this.addEventListener('change', (e) => {
      if (e.target.matches('[data-fy-option-input]')) this.onOptionChange();
    });

    this.bindQuantity();
    this.bindStickyBar();
  }

  bindQuantity() {
    const input = this.querySelector('[data-fy-qty-input]');
    if (!input) return;
    const step = (delta) => {
      const next = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    this.querySelector('[data-fy-qty-down]')?.addEventListener('click', () => step(-1));
    this.querySelector('[data-fy-qty-up]')?.addEventListener('click', () => step(1));
  }

  bindStickyBar() {
    const bar = this.querySelector('[data-fy-stickybar]');
    const atc = this.querySelector('[data-fy-atc]');
    if (!bar || !atc || !('IntersectionObserver' in window)) return;

    bar.hidden = false;
    this.barObserver = new IntersectionObserver(
      ([entry]) => {
        // Show only once the real button has scrolled off the TOP of the screen,
        // so the bar never covers the button it duplicates.
        const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', passed);
      },
      { threshold: 0 }
    );
    this.barObserver.observe(atc);
  }

  disconnectedCallback() {
    if (this.barObserver) this.barObserver.disconnect();
  }

  selectedOptions() {
    return this.optionGroups.map((group) => {
      const select = group.querySelector('select[data-fy-option-input]');
      if (select) return select.value;
      const checked = group.querySelector('input[data-fy-option-input]:checked');
      return checked ? checked.value : null;
    });
  }

  onOptionChange() {
    const chosen = this.selectedOptions();
    const variant = this.variants.find(
      (v) => v.options.length === chosen.length && v.options.every((o, i) => o === chosen[i])
    );

    this.optionGroups.forEach((group, i) => {
      const label = group.querySelector('[data-fy-option-value]');
      if (label && chosen[i]) label.textContent = chosen[i];
    });

    this.render(variant);
  }

  render(variant) {
    const q = (sel) => this.querySelector(sel);

    if (!variant) {
      const atc = q('[data-fy-atc]');
      if (atc) {
        atc.disabled = true;
        const label = q('[data-fy-atc-label]');
        if (label) label.textContent = 'Unavailable';
      }
      q('[data-fy-sticky-atc]') && (q('[data-fy-sticky-atc]').disabled = true);
      return;
    }

    if (this.idInput) this.idInput.value = variant.id;

    // Price
    const now = q('[data-fy-price-now]');
    const was = q('[data-fy-price-was]');
    const saving = q('[data-fy-price-saving]');
    if (now) {
      now.textContent = variant.price;
      now.classList.toggle('fy-price__now--sale', !!variant.compare_at);
    }
    if (was) {
      was.textContent = variant.compare_at || '';
      was.hidden = !variant.compare_at;
    }
    if (saving) {
      saving.hidden = !variant.compare_at;
      if (variant.compare_at) {
        saving.textContent =
          saving.dataset.style === 'amount'
            ? saving.dataset.label + ' ' + variant.saving_amount
            : saving.dataset.label + ' ' + variant.saving_percent + '%';
      }
    }

    // Buy button
    const atc = q('[data-fy-atc]');
    const atcLabel = q('[data-fy-atc-label]');
    if (atc) atc.disabled = !variant.available;
    if (atcLabel && atc) {
      atcLabel.textContent = variant.available ? atc.dataset.addLabel : atc.dataset.soldOutLabel;
    }

    // Sticky bar
    const sPrice = q('[data-fy-sticky-price]');
    const sWas = q('[data-fy-sticky-was]');
    const sAtc = q('[data-fy-sticky-atc]');
    const sLabel = q('[data-fy-sticky-label]');
    if (sPrice) sPrice.textContent = variant.price;
    if (sWas) {
      sWas.textContent = variant.compare_at || '';
      sWas.hidden = !variant.compare_at;
    }
    if (sAtc) sAtc.disabled = !variant.available;
    if (sLabel && sAtc) {
      sLabel.textContent = variant.available ? sAtc.dataset.addLabel : (atc ? atc.dataset.soldOutLabel : 'Sold out');
    }

    // Availability
    const stock = q('[data-fy-stock]');
    if (stock) {
      const text = stock.querySelector('[data-fy-stock-text]');
      const threshold = parseInt(stock.dataset.lowThreshold, 10) || 0;
      const tracked = variant.inventory_management === 'shopify';
      stock.classList.remove('is-low', 'is-out');
      if (!variant.available) {
        stock.classList.add('is-out');
        if (text) text.textContent = stock.dataset.outText;
      } else if (tracked && threshold > 0 && variant.inventory_quantity > 0 && variant.inventory_quantity <= threshold) {
        stock.classList.add('is-low');
        if (text) text.textContent = (stock.dataset.lowText || '').replace('[qty]', variant.inventory_quantity);
      } else if (text) {
        text.textContent = stock.dataset.inText;
      }
    }

    // Selling-out tab. Recomputed per variant so it only appears when that
    // variant's real stock satisfies the rule.
    const urgency = q('[data-fy-urgency]');
    if (urgency) {
      const mode = urgency.dataset.mode;
      const threshold = parseInt(urgency.dataset.threshold, 10) || 0;
      const tracked = variant.inventory_management === 'shopify';
      const qty = variant.inventory_quantity;
      let show = false;
      if (variant.available && mode === 'always') {
        show = true;
      } else if (variant.available && mode === 'auto') {
        show = tracked && qty > 0 && qty <= threshold;
      }
      urgency.classList.toggle('is-hidden', !show);
      const body = urgency.querySelector('[data-fy-urgency-text]');
      if (body && show) body.textContent = (urgency.dataset.body || '').replace('[qty]', qty);
    }

    // Gallery + URL
    if (variant.media_id && this.gallery) this.gallery.selectByMediaId(variant.media_id);
    if (this.dataset.url && window.history.replaceState) {
      window.history.replaceState({}, '', this.dataset.url + '?variant=' + variant.id);
    }
  }
}
if (!customElements.get('fieldory-product')) customElements.define('fieldory-product', FieldoryProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fieldory-related"] && !Shopify.designMode) return;
  try {
    
/* Swap in Shopify's recommendations once they are available. The server-side
   fallback is already rendered, so this only ever improves the result. */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-fy-related]').forEach((el) => {
    const url = el.dataset.url;
    if (!url || el.dataset.loaded === 'true') return;
    el.dataset.loaded = 'true';
    fetch(url)
      .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
      .then((text) => {
        const fresh = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('[data-fy-related] .fy-container--flush');
        const current = el.querySelector('.fy-container--flush');
        if (fresh && fresh.querySelector('.fy-rel__cell')) {
          if (current) current.replaceWith(fresh);
          else el.appendChild(fresh);
        }
      })
      .catch(() => {});
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fieldory-reviews"] && !Shopify.designMode) return;
  try {
    
/* Review photo lightbox. Photos open here, on the page — never a new tab to
   whatever CDN the review was synced from. */
(function () {
  function init(root) {
    var box = root.querySelector('[data-fy-lightbox]');
    var dataEl = root.querySelector('[data-fy-lightbox-data]');
    if (!box || !dataEl) return;

    var reviews;
    try { reviews = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!reviews || !reviews.length) return;

    // Flatten to a single walkable list of photos.
    var flat = [];
    reviews.forEach(function (r, ri) {
      (r.pics || []).forEach(function (src) {
        flat.push({ src: src, name: r.name, rating: r.rating, date: r.date, body: r.body, review: ri });
      });
    });
    if (!flat.length) return;

    var img = box.querySelector('[data-fy-lightbox-img]');
    var elName = box.querySelector('[data-fy-lightbox-name]');
    var elStars = box.querySelector('[data-fy-lightbox-stars]');
    var elDate = box.querySelector('[data-fy-lightbox-date]');
    var elBody = box.querySelector('[data-fy-lightbox-body]');
    var elCount = box.querySelector('[data-fy-lightbox-count]');
    var current = 0;
    var lastFocus = null;

    function show(i) {
      current = (i + flat.length) % flat.length;
      var p = flat[current];
      img.src = p.src;
      img.alt = 'Customer photo from ' + p.name;
      if (elName) elName.textContent = p.name;
      if (elStars) {
        var n = Math.round(parseFloat(p.rating) || 0);
        elStars.textContent = '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n);
      }
      if (elDate) elDate.textContent = p.date || '';
      if (elBody) elBody.textContent = p.body || '';
      if (elCount) elCount.textContent = (current + 1) + ' of ' + flat.length;
    }

    function open(reviewIndex, startOffset) {
      var i = flat.findIndex(function (p) { return p.review === reviewIndex; });
      if (i < 0) i = 0;
      i += parseInt(startOffset, 10) || 0;
      lastFocus = document.activeElement;
      show(i);
      box.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var closeBtn = box.querySelector('[data-fy-lightbox-close]');
      if (closeBtn && closeBtn.focus) closeBtn.focus();
    }

    function close() {
      box.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    root.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-fy-lightbox-open]');
      if (opener) {
        event.preventDefault();
        open(parseInt(opener.getAttribute('data-fy-lightbox-open'), 10),
             opener.getAttribute('data-fy-lightbox-start'));
        return;
      }
      if (event.target.closest('[data-fy-lightbox-close]')) { close(); return; }
      if (event.target.closest('[data-fy-lightbox-prev]')) { show(current - 1); return; }
      if (event.target.closest('[data-fy-lightbox-next]')) { show(current + 1); return; }
    });

    document.addEventListener('keydown', function (event) {
      if (box.hidden) return;
      if (event.key === 'Escape') close();
      else if (event.key === 'ArrowLeft') show(current - 1);
      else if (event.key === 'ArrowRight') show(current + 1);
    });
  }

  function boot() {
    document.querySelectorAll('.fy-rev').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
